export default __webpack_public_path__ + "static/media/customer-img.4ded38cb.webp";